import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { BRAND } from "../data/content";

export default function Concierge() {
  const [open, setOpen] = useState(false);
  const waLink = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hello, I would like to speak with a travel curator.")}`;

  return (
    <div className="fixed bottom-6 right-6 z-[65] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="w-72 bg-navy text-ivory border border-gold/30 shadow-2xl grain p-6"
            data-testid="concierge-panel"
          >
            <p className="overline text-gold/80">Private Concierge</p>
            <p className="font-serif text-2xl mt-3 leading-snug">How may we craft your next journey?</p>
            <p className="text-ivory/60 text-sm mt-3 leading-relaxed">Speak directly with a travel curator, discreetly and without obligation.</p>
            <a href={waLink} target="_blank" rel="noreferrer" data-testid="concierge-whatsapp" className="btn-gold w-full justify-center mt-5 !py-3">
              <MessageCircle size={16} /> Chat on WhatsApp
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="concierge-button"
        aria-label="Concierge"
        className="h-14 w-14 rounded-full bg-gold text-navy flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
}
